import { queryOptions } from '@tanstack/react-query'

import { isTerminalInvoice } from '../model/invoice-status'

import { fetchInvoices, fetchPlans } from './billing-api'
import { billingKeys } from './query-keys'

const INVOICE_POLL_MS = 10_000

export const plansQuery = () =>
  queryOptions({
    queryKey: billingKeys.plans(),
    queryFn: ({ signal }) => fetchPlans(signal),
    // Plans change rarely; a stale window avoids a refetch on every visit.
    staleTime: 5 * 60_000,
  })

export const invoicesQuery = () =>
  queryOptions({
    queryKey: billingKeys.invoices(),
    queryFn: ({ signal }) => fetchInvoices(signal),
    // Poll while any invoice is still moving; stop once all are terminal.
    refetchInterval: (query) => {
      const data = query.state.data
      if (data === undefined) return false
      return data.some((invoice) => !isTerminalInvoice(invoice.status)) ? INVOICE_POLL_MS : false
    },
  })
